import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import Modal from '@mui/material/Modal';
import DialogContent from '@mui/material/DialogContent';

import { setUser } from '../../store/actions/Users/action';
import { resetReducers, setSelectedDateRange, setSelectedDateRangePicker } from '../../store/actions/Alerts/action';
import * as Q from '../../constants/graphqlQueries';

import Header from './components/Header';
import NotFound from './NotFound';
import Landing from '../Landing/Landing';
import CodeMapping from '../Modules/CodeMapping/CodeMapping';
import RulesConfiguration from '../Modules/RulesConfiguration/RulesConfiguration';
import TeamAlerts from '../Modules/TeamAlerts/TeamAlerts';
import AdminManagement from '../Modules/AdminManagement/AdminManagement';
import Dashboards from '../Modules/Dashboards/Dashboards';
import Administration from '../Modules/Administration/Administration';
import initialState from '../../store/reducers/Alerts/initialState';
import AccessDenied from '../Errors/AccessDenied';
import ModalDetail from '../ModalDetail/ModalDetail';
import { authenticationDenied } from '../../constants/accessDeniedMessages';
import CustomSpinner from '../components/LoadingScreens/CustomSpinner';
import Reporting from '../Modules/Reporting/Reporting';

const { selectedDateRangePicker } = initialState();
const { selectedDateRange } = initialState();

const AppRouter = ({
  email, logout, resetReducers, setUser, setSelectedDateRangePicker,
}) => {
  const user = useSelector((state) => state.User);
  const [open, setOpen] = useState(false);

  const { loading, error, data } = useQuery(Q.SECURITY_USER_GB_EMAIL_QUERY, {
    variables: { email }
  });
  console.log("AppRouter.jsx:AppRouter Query Email:", email);
  console.log("AppRouter.jsx:AppRouter Query Data (before the graphql call):", data);
  console.log("AppRouter.jsx:Will make the GraphQL call to get user data.");
  useEffect(() => {
    if (data) {
      if (data.user) {
        console.log("AppRouter.jsx:GraphQL call Done. User Found:");
        const userPayload = {
          Claims: data.user.Claims,
          EmployeeId: data.user.EmployeeId,
          Role: data.user.AppRole,
          UserId: data.user.UserId,
          EmailAddress: data.user.EmailAddress,
          LastName: data.user.LastName,
          FirstName: data.user.FirstName,
          AuthenticatedEmail: email,
          IsImpersonated: false
        };
        console.log("AppRouter.jsx: Will setUser.");
        setUser(userPayload);
        setSelectedDateRange(selectedDateRange);
        setSelectedDateRangePicker(selectedDateRangePicker);
      }
      else {
        console.log("AppRouter.jsx:GraphQL call Done. User NOT Found:data.user is undefined.");
      }
    }
    else {
      console.log("AppRouter.jsx:GraphQL call Done. User NOT Found:data is undefined.");
    }
  }, [data]);

  if (loading) return <CustomSpinner />;
  if (error && !open) setOpen(true);

  if (data) {
    if (data.user === null) {
      console.log("AppRouter.jsx:User NOT Found:data.user === null. Will return AccessDenied.");
      return <AccessDenied />;
    }
  }

  if (open) {
    console.log("AppRouter.jsx:Will display the error popup - Authentication required to access.");
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
      >
        <DialogContent className="dialog delete-rule">
          <ModalDetail className="modal delete-rule" modalOptions={authenticationDenied} />
        </DialogContent>
      </Modal>
    );
  }

  const onSignOut = async (_logout) => {
    await resetReducers();
    _logout();
  };

  const setAlertCountsFunction = (counts) => {
    console.log("Updating alert counts:", counts);
  };
  
  const setImpersonateUserAsUserFunction = (user) => {
    console.log("Impersonating user:", user);
  };
  

  return (
    user.EmployeeId > 0 && (
      <div>
        <div>
          <Header 
            onSignOut={onSignOut} logout={logout} 
            setAlertCounts={setAlertCountsFunction} 
            setImpersonateUserAsUser={setImpersonateUserAsUserFunction} />
        </div>
        <div className="__hero--container--main">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/Landing" element={<Landing />} />
            <Route path="/CodeMapping" element={<CodeMapping />} />
            <Route path="/RulesConfiguration" element={<RulesConfiguration />} />
            <Route path="/TeamAlerts" element={<TeamAlerts />} />
            <Route path="/AdminManagement" element={<AdminManagement />} />
            <Route path="/Dashboards" element={<Dashboards />} />
            <Route path="/Administration" element={<Administration />} />
            <Route path="/Reporting" element={<Reporting />} />
            <Route path="/AccessDenied" element={<AccessDenied />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    )
  );
};

AppRouter.propTypes = {
  email: PropTypes.string,
  logout: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  resetReducers: PropTypes.func.isRequired,
  setSelectedDateRangePicker: PropTypes.func.isRequired,
};

AppRouter.defaultProps = {
  email: null
};

const mapDispatchToProps = (dispatch) => ({
  setUser(user) {
    dispatch(setUser(user));
  },
  resetReducers() {
    dispatch(resetReducers());
  },
  setSelectedDateRangePicker(payload) {
    dispatch(setSelectedDateRangePicker(payload));
  },
});

export default connect(null, mapDispatchToProps)(AppRouter);
